export const BONUS_BY_PRODUCT_CARDS_PT_BR = {
	totalProductsValue: "Bonificação total em Produtos",
	totalTipValue: "Bonificação total em propina",
	totalValue: "Total",
	receivedInPeriod: "Recebido no evento",
	receivedAtAnotherPeriod: "Recebido em outros eventos",
};

export type BonusByProductCardsTranslations = typeof BONUS_BY_PRODUCT_CARDS_PT_BR;
